import { Approver } from "../types/approvers";
import { CreateDrawRequest, DrawRequest, DrawRequestResp } from '../types/draw-request';
import { PaymentMethod } from "../types/payment-method";
import { callApiInstance, apiInstance } from "./api";

class DrawRequestsService {

  async getAllDrawRequests(status: "approve" | "deny" | "" | null, startDate: string, endDate: string): Promise<DrawRequest[]> {

    return (await callApiInstance({ url: `/DrawRequest?status=${status}&startDate=${startDate}&endDate=${endDate}` })).data;
  }
  async getAllDrawRequestsNew(data: { status: "approved" | "denied" | "" | null, startDate: string, endDate: string, paymentType: number[], filterApprovalStatusValue: string, controlNumber: string, myApproval: boolean }): Promise<DrawRequestResp[]> {

    return (await callApiInstance({ url: `/DrawRequest/GetAll?accountingApprovalStatus=${data.status}&startDate=${data.startDate}&endDate=${data.endDate}&paymentType=${data.paymentType || []}&approvalStatus=${data.filterApprovalStatusValue}&controlNumber=${data.controlNumber}&myApproval=${data.myApproval}` })).data;
  }
  async approveAllRequests(data: DrawRequest[]) {
    return (await callApiInstance({
      url: "/DrawRequest/ApproveAllDrawRequest",
      method: "POST",
      data
    })).data;
  }
  async approveAllRequestsV2(data: DrawRequestResp[]) {
    return (await callApiInstance({
      url: "/DrawRequest/ApproveAllDrawRequest",
      method: "POST",
      data
    })).data;
  }
  async createDrawRequest(data: CreateDrawRequest) {

    return (await callApiInstance({ url: "/DrawRequest", method: "POST", data })).data;
  }
  async createNewDrawRequest(data: CreateDrawRequest): Promise<DrawRequest> {
    return (await callApiInstance({ url: "/DrawRequest", method: "POST", data })).data;
  }
  //   async getSingle(id: string) {
  //     return a(wait callApiInstance({ url: `/Project/${id}` })).data;
  //   }
  async editDrawRequest(id: number, data: CreateDrawRequest): Promise<DrawRequest> {
    return (await callApiInstance({ url: `/DrawRequest/${id}`, method: "PUT", data })).data;
  }

  async getDrawRequestById(id: number | string): Promise<DrawRequestResp> {
    return (await callApiInstance({ url: `/DrawRequest/${id}` })).data;
  }

  async getFormOptions(): Promise<{ approvers: Approver[], expatOfficers: Approver[], paymentMethods: PaymentMethod[] }> {

    return (await callApiInstance({ url: `/DrawRequest/formOptions` })).data;
  }
  async approveDrawRequest(id: number | string, signature: string,): Promise<DrawRequestResp> {
    return (await callApiInstance({ url: `/DrawRequest/${id}/approve`, method: 'PUT', data: { signature }, headers: { "Content-Type": "application/json", } })).data;
  }
  async denyDrawRequest(id: number | string, issues: {
    title: string;
    description: string;
  }[],): Promise<DrawRequestResp> {
    return (await callApiInstance({ url: `/DrawRequest/${id}/approve/false`, method: 'PUT', data: { issues }, headers: { "Content-Type": "application/json", } })).data;
  }
  async approveDenyTransaction(id: number | string, isApprove?: boolean
  ): Promise<DrawRequestResp> {
    const value = isApprove === undefined ? true : isApprove

    return (await callApiInstance({ url: `/DrawRequest/${id}/approveTransaction/${value}`, method: 'PUT', })).data;
  }


  async deleteDrawRequest(id: number) {
    return (await callApiInstance({ url: `/DrawRequest/${id}`, method: "DELETE" })).data;
  }

  async voidDrawRequest(id: number) {
    return (await callApiInstance({ url: `/DrawRequest/${id}/void`, method: "PUT" })).data;
  }
  async modifyAlreadyDownloadedDrawRequest(id: number, value: boolean) {
    return (await callApiInstance({ url: `/DrawRequest/${id}/alreadyDownloaded/${value}`, method: "PUT" })).data;
  }
  async getAllCsv(status: "approved" | "denied" | "" | null, startDate: string, endDate: string, paymentType: number[] = [], filterApprovalStatusValue: string, isBulk: boolean = false) {

    const urlAux = !isBulk ? 'csv' : 'bulk-pdf'

    const url = `/DrawRequest/${urlAux}?accountingApprovalStatus=${status}&startDate=${startDate}&endDate=${endDate}&paymentType=${paymentType}&approvalStatus=${filterApprovalStatusValue}`

    return (await callApiInstance({
      url,
      responseType: 'arraybuffer'
    })).data;
  }
  async GetAllPDFsByDRid(id: number) {
    return await callApiInstance({ url: `/DrawRequest/${id}/GetAllPdfs`, responseType: 'blob', });
  }
  async getDocByDRid(id: number) {
    return await callApiInstance({ url: `/Document/${id}`, responseType: 'blob', });
  }

  async updatePaymentForm(isCreated: boolean, id: string, paymentForm: string, files: {
    invoiceCapitalCallDoc: File[];
    agreementDocID: File | null | undefined;
    sanctionDoc: File | null | undefined;
    achWireInstructions: File | null | undefined;
    w9Form: File | null | undefined;
  } = {
      invoiceCapitalCallDoc: [],
      agreementDocID: null,
      sanctionDoc: null,
      achWireInstructions: null,
      w9Form: null,
    }) {

    if (!id) return

    const formData = new FormData();

    /**============================================
     *               adding fields
     *=============================================**/
    (files.invoiceCapitalCallDoc || []).forEach((file, index) => {
      // formData.append(`invoiceCapitalCallDoc[${index}]`, file);
      formData.append(`invoiceCapitalCallDoc`, file);
    });
    if (files.agreementDocID) {
      // formData.append('agreementDoc[0]', files.agreementDocID);
      formData.append('agreementDoc', files.agreementDocID);
    }
    if (files.sanctionDoc) {
      formData.append('sanctionDoc', files.sanctionDoc);
    }
    if (files.achWireInstructions) {
      formData.append('achWireInstructions', files.achWireInstructions);
    }
    if (files.w9Form) {
      formData.append('w9Form', files.w9Form);
    }

    formData.append('drawRequest', id);
    formData.append('paymentForm', paymentForm);


    /*=============== END OF SECTION ==============*/

    if (isCreated)
      return (await apiInstance.put(`/DrawRequest/WithPaymentFormAndFiles/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })).data;
    else
      return (await apiInstance.put(`/DrawRequest/WithPaymentFormAndFiles/Draft/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })).data;

  }
  async createDrawRequestNew(isCreate: boolean, drawRequest: number, paymentForm: string, files: {
    invoiceCapitalCallDoc: File[];
    agreementDocID: File | null | undefined;
    sanctionDoc: File | null | undefined;
    achWireInstructions: File | null | undefined;
    w9Form: File | null | undefined;
  } = {
      invoiceCapitalCallDoc: [],
      agreementDocID: null,
      sanctionDoc: null,
      achWireInstructions: null,
      w9Form: null,
    }) {
    const formData = new FormData();

    /**============================================
     *               adding fields
     *=============================================**/
    (files.invoiceCapitalCallDoc || []).forEach((file, index) =>
      // formData.append(`invoiceCapitalCallDoc[${index}]`, file)
      formData.append(`invoiceCapitalCallDoc`, file)
    );

    if (files.agreementDocID) {
      // formData.append('agreementDoc[0]', files.agreementDocID);
      formData.append('agreementDoc', files.agreementDocID);
    }
    if (files.sanctionDoc) {
      formData.append('sanctionDoc', files.sanctionDoc);
    }
    if (files.achWireInstructions) {
      formData.append('achWireInstructions', files.achWireInstructions);
    }
    if (files.w9Form) {
      formData.append('w9Form', files.w9Form);
    }


    formData.append('drawRequest', `${drawRequest}`);
    formData.append('paymentForm', paymentForm);


    /*=============== END OF SECTION ==============*/
    if (isCreate)
      return (await apiInstance.post('/DrawRequest/WithPaymentFormAndFiles', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })).data;

    else
      return (await apiInstance.post(`/DrawRequest/WithPaymentFormAndFiles/Draft`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })).data;

  }
  // async createOrUpdateDrawRequest(isCreate: boolean, id: string | undefined, drawRequest: string, paymentForm: string, files: {
  //   invoiceCapitalCallDoc: File[];
  //   agreementDocID: File | null | undefined;
  //   sanctionDoc: File | null | undefined;
  // } = {
  //     invoiceCapitalCallDoc: [],
  //     agreementDocID: null,
  //     sanctionDoc: null,
  //   }) {
  //   const formData = new FormData();

  //   /**============================================
  //    *               adding fields
  //    *=============================================**/
  //   files.invoiceCapitalCallDoc.forEach((file, index) => {


  //     formData.append(`invoiceCapitalCallDoc[${index}]`, file);
  //   });
  //   if (files.agreementDocID) {
  //     formData.append('agreementDoc[0]', files.agreementDocID);
  //   }
  //   if (files.sanctionDoc) {

  //     formData.append('sanctionDoc', files.sanctionDoc);
  //   }
  //   formData.append('drawRequest', drawRequest);
  //   formData.append('paymentForm', paymentForm);


  //   /*=============== END OF SECTION ==============*/
  //   if (isCreate) return await apiInstance.post('/DrawRequest/WithPaymentFormAndFiles', formData, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //   });

  //   else return await apiInstance.put(`/DrawRequest/WithPaymentFormAndFiles/${id}`, formData, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //   });

  // }

}
export const drawRequestsService = new DrawRequestsService();
